<script>
import Loader from "@/components/widgets/loader";
import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import XLSX from "xlsx";
import Drawer from "vue-simple-drawer";

export default {
  mixins: [Api, Sabit],
  page: {
    title: "Anket Oluştur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Loader,Drawer },
  data() {
    return {
      title: this.$t("CreateAnket.Title"),
      items: [
        {
          text: this.$t("CreateAnket.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "100",
        PageDataSize: "1",
      },
      DosyaYolu:"",
      AnktAnketId: this.$route.params.AnktAnketId,
      FormData: [],
      FormJson: [],
      Cevaplar: [],
      CevapData: [],
      ExcelJSON: [],
      loading: true,
      isLoading: true,
      word: "",
      updating: false,

      uri: "data:application/vnd.ms-excel;base64,",
      template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
      FilitrelemePenceresi: false,
      AnketFilter:{},
      AnketFilterText:""
    };
  },
  methods: {
    FileDowland(file) {
      let dosya_adi = file.substr(5, file.length - 5);

      let Filter = "?fileName=" + dosya_adi + "&pathUrl=Ankt";

      this.ActionsFileGet({ Service: "GenericFileUpDownload/DownloadFile", Filter }).then((res) => {
        if (res) {
          let blob = new Blob([res]);
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = dosya_adi;
          link.click();
        }
      });
    },
    Get() {
      this.ActionsFilterGet({
        Service: "AnktAnketCevap",
        Page: this.Page,
        Filter: "&Anketid=" + this.AnktAnketId + "&Sorufiltre=" + this.AnketFilterText,
      }).then((res) => {
        this.CevapData = JSON.parse(res.Data);
        console.log("CevapData",JSON.stringify(this.CevapData));
        this.Page.PageDataSize = this.CevapData[0].totalcount;
        this.loading = false;
        //this.$refs.Loader___BV_modal_body_.style = "background: none;"
        //document.getElementById("Loader___BV_modal_body_").style.background = "none";
        this.$refs.Loader___BV_modal_body_.style.background = "none";
      });
    },
    ExportJSON(islem) {
      this.updating = true;
      this.loading = true;
      let Anket = this.FormJson;

       console.log("FormJson",JSON.stringify(this.FormJson));

      var Sorgu = "select ";

      for (let i = 0; i < Anket.length; i++) {
        for (let j = 0; j < Anket[i].FormFiled.length; j++) {
          if (Anket[i].FormFiled[j].type != "file") {
            if (Sorgu != "select ") {
              Sorgu += ", ";
            }

            if (Anket[i].FormFiled[j].type == "input" || Anket[i].FormFiled[j].type == "time" || Anket[i].FormFiled[j].type == "date" || Anket[i].FormFiled[j].type == "textarea" || Anket[i].FormFiled[j].type == "rangeslider") {
              Sorgu += "cevap->'" + Anket[i].FormFiled[j].Id + "' ->> 'Cevap' as \"" + Anket[i].FormFiled[j].props.title + "\"";
              Sorgu += "";
            } else if (Anket[i].FormFiled[j].type == "radiobutton" || Anket[i].FormFiled[j].type == "combobox") {
              Sorgu += "concat( ";
              for (let s = 0; s < Anket[i].FormFiled[j].options.length; s++) {
                if (s != 0) {
                  Sorgu += " , '   ' ,";
                }
                Sorgu += " case WHEN cevap->'" + Anket[i].FormFiled[j].Id + "' ->> 'Cevap' = '" + Anket[i].FormFiled[j].options[s].Id + "' THEN '" + Anket[i].FormFiled[j].options[s].value.replaceAll(" ", "") + "' END ";
              }
              Sorgu += ")   as \"" + Anket[i].FormFiled[j].props.title + "\"";
            } else if (Anket[i].FormFiled[j].type == "checkbox") {
  Sorgu += " array_to_string(array_remove( ARRAY[ ";

  for (let s = 0; s < Anket[i].FormFiled[j].options.length; s++) {

    if (s != 0) {
      Sorgu += " , ";
    }
    Sorgu += " case WHEN (cevap->'" + Anket[i].FormFiled[j].Id + "' -> 'Cevap' ->> '" + Anket[i].FormFiled[j].options[s].Id + "')::boolean THEN '" + Anket[i].FormFiled[j].options[s].value.replaceAll(" ", "") + "' ELSE NULL END ";
  }

  Sorgu += " ], NULL ), ', ') as \"" + Anket[i].FormFiled[j].props.title + "\"";
}else if (Anket[i].FormFiled[j].type == "OnayKutuluTablo") {
              for (let s = 0; s < Anket[i].FormFiled[j].options.Satir.length; s++) {
                if (s != 0) {
                  Sorgu += ", ";
                }
                Sorgu += "concat( ";

                for (let d = 0; d < Anket[i].FormFiled[j].options.Sutun.length; d++) {
                  if (d != 0) {
                    Sorgu += " , ' , ' ,";
                  }
                  Sorgu += " case WHEN (cevap->'" + Anket[i].FormFiled[j].Id + "' -> 'Cevap' -> '" + Anket[i].FormFiled[j].options.Satir[s].Id + "' ->> '" + Anket[i].FormFiled[j].options.Sutun[d].Id + "')::boolean is true THEN '" + Anket[i].FormFiled[j].options.Sutun[d].value.replaceAll(" ", "") + "' END ";
                }

                Sorgu += ")   as \"" + Anket[i].FormFiled[j].options.Satir[s].value + "\"";
              }
            } else if (Anket[i].FormFiled[j].type == "CoktanSecmeliTablo") {
              for (let s = 0; s < Anket[i].FormFiled[j].options.Satir.length; s++) {
                if (s != 0) {
                  Sorgu += ", ";
                }
                Sorgu += "concat( ";

                for (let d = 0; d < Anket[i].FormFiled[j].options.Sutun.length; d++) {
                  if (d != 0) {
                    Sorgu += " , '   ' ,";
                  }
                  Sorgu += " case WHEN cevap->'" + Anket[i].FormFiled[j].Id + "' -> 'Cevap' ->> '" + Anket[i].FormFiled[j].options.Satir[s].Id + "' = '" + Anket[i].FormFiled[j].options.Sutun[d].Id + "' THEN '" + Anket[i].FormFiled[j].options.Sutun[d].value.replaceAll(" ", "") + "' END ";
                }

                Sorgu += ")   as \"" + Anket[i].FormFiled[j].options.Satir[s].value + "\"";
              }
            }
          }
        }
       
      }
       Sorgu += ",to_char(created, 'dd-mm-yyyy HH24:MI') as \"Cevaplama Tarihi\"";

        Sorgu += " from anktanketcevap WHERE anketid='" + this.AnktAnketId + "'";

         console.log("Sorgu",Sorgu);
 
        let Data = {
          Filter: Sorgu,
        };
        this.ActionsPost({
          Service: "AnktAnketCevap/RaporlamaExcel",
          Data: Data,
        }).then((res) => {
          //console.log(res);
          this.ExcelJSON = res;

           console.log("ExcelJSON",JSON.stringify(this.ExcelJSON));
 

          this.word = res;
          if (islem == "excel") {
            this.exportToExcel();
          } else {
            this.exportToWord();
          }
          this.$bvModal.hide("Loader");
          this.loading = false;
        });
    },

    exportToExcel() {
      var animalWS = XLSX.utils.json_to_sheet(this.ExcelJSON);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, animalWS, "animals");
      XLSX.writeFile(wb, this.FormData.Baslik+".xlsx");
    },
    exportToWord() {
      let Table = "<table border='1'>";
      Table += "<thead><tr>";

      let addedTitles = new Set();

      for (let i = 0; i < this.FormJson.length; i++) {
        for (let j = 0; j < this.FormJson[i].FormFiled.length; j++) {
          const field = this.FormJson[i].FormFiled[j];

          if (field.type !== "file") {
            if (field.type !== "OnayKutuluTablo" && field.type !== "CoktanSecmeliTablo") {
              if (!addedTitles.has(field.props.title)) { // aynı başlık eklenmesin
                addedTitles.add(field.props.title);
                Table += `<td>${field.props.title}</td>`;
              }
            } else {
              for (let s = 0; s < field.options.Satir.length; s++) {
                const satirTitle = field.options.Satir[s].value;
                if (!addedTitles.has(satirTitle)) {
                  addedTitles.add(satirTitle);
                  Table += `<td>${satirTitle}</td>`;
                }
              }
            }
          }
        }
      }

      Table += "<td>Cevaplama Tarihi</td></tr></thead><tbody>";

      for (let i = 0; i < this.word.length; i++) {
        Table += "<tr>";
        for (let Icerik in this.word[i]) {
          Table += `<td>${this.word[i][Icerik] ?? ""}</td>`;
        }
        Table += "</tr>";
      }

      Table += "</tbody></table>";
      this.word = Table;

      const vm = this;
      const word = `
        <html xmlns:o='urn:schemas-microsoft-com:office:office'
              xmlns:w='urn:schemas-microsoft-com:office:word'
              xmlns='http://www.w3.org/TR/REC-html40'>
          <head><meta charset='utf-8'>
            <title>Export HTML to Word Document with JavaScript</title>
          </head>
          <body>${vm.word}</body>
        </html>`;

      const source = "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(word);
      const fileDownload = document.createElement("a");
      document.body.appendChild(fileDownload);
      fileDownload.href = source;
      fileDownload.download = this.FormData.Baslik + ".doc";
      fileDownload.click();
      document.body.removeChild(fileDownload);
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    FilterDuzenleme(){ 
      this.AnketFilterText = ""
      for(var filter in this.AnketFilter){ 
        if(this.AnketFilter[filter]){
        this.AnketFilterText += "and row.cevap::jsonb->'" + filter + "' ->> 'Cevap' ='" + this.AnketFilter[filter] + "'"
        }
      } 
      this.Get();
    }
  },
  created() {
    this.DosyaYolu = this.$config.FILES_URL;
    this.ActionsSingleGet({
      Service: "AnktAnket",
      Id: this.AnktAnketId,
    }).then((res) => {
      this.FormData = res.Data;
      this.FormJson = JSON.parse(this.FormData.Anketjson);
      this.loading = false;
    });

    let Data = {
      Filter: "select cevap from anktanketcevap WHERE anketid='" + this.AnktAnketId + "' ",
    };
    this.ActionsPost({
      Service: "AnktAnketCevap/Raporlama",
      Data: Data,
    }).then((res) => {
      this.Cevaplar = res;
    });
  },
};
</script>
<style>
/*
.dropdown-menu.show {
  overflow-y: scroll !important;
  height: 200px !important;
}
 
 
*/
#Loader___BV_modal_content_ {
  background: none !important;
  border: none !important;
}
</style>
<template>
  <Loader :loading="updating">
    <div v-if="FormJson">
      <b-modal id="Loader" size="lg" title-class="font-18" hide-footer hide-header centered
        ><div class="text-sm-center" v-if="loading"><b-spinner type="grow" class="m-2" variant="success" role="status"></b-spinner><b-spinner type="grow" class="m-2" variant="success" role="status"></b-spinner><b-spinner type="grow" class="m-2" variant="success" role="status"></b-spinner></div>
      </b-modal>
 
      <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("AnktAnket.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("AnktAnket.Filtreleme.Content") }}

            <div v-for="(Bolumler, Bolumindex) in FormJson" :key="Bolumindex">
              <template v-for="(Form, index) in Bolumler.FormFiled">
                <b-form-group
                  :key="index"
                  :label="Form.props.title"
                  label-for="text"
                  class="mt-3"
                    v-if="Form.type == 'combobox' || Form.type == 'radiobutton'"
                >
                  <select
                    class="form-select"
                    type="text"
                    v-model="AnketFilter[Form.Id]"
                  >
                    <option value="">Seçiniz</option>
                    <option
                      v-for="options in Form.options"
                      :key="options.Id"
                      :value="options.Id"
                    >
                      {{ options.value }}
                    </option>
                  </select>
                </b-form-group></template
              >
            </div>

            <b-button
              @click="FilterDuzenleme()"
              class="btn btn-primary mt-3"
              variant="primary"
            >
              {{ $t("AnktAnket.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>

      <div>
        <div class="text-sm-end">
          <button v-b-modal.Loader type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="ExportJSON('excel')">
            <i class="mdi mdi-file-export-outline me-1"></i>
            {{ $t("AnktDetay.Page.YanitlarGridTab.ExceleAktarBtn") }}
          </button>
          <button v-b-modal.Loader type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="ExportJSON('word')">
            <i class="mdi mdi-file-export-outline me-1"></i>
            {{ $t("AnktDetay.Page.YanitlarGridTab.WordAktarBtn") }}
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-rounded mb-2 me-2"
            @click="rightDrawer()"
          >
            <i class="mdi mdi-text-search me-1"></i>
            {{ $t("AnktAnket.Page.Filtreleme") }}
          </button>
        </div>

        <div class="table-responsive">
          <table class="table table-hover mb-0" ref="table">
            <thead>
              <tr>
                <template v-for="Bolumler in FormJson">
                  <template v-for="(Form, index) in Bolumler.FormFiled">
                    <th :key="index" v-if="Form.type != 'OnayKutuluTablo' && Form.type != 'CoktanSecmeliTablo'">
                      {{ Form.props.title }}
                    </th>

                    <template v-if="Form.type == 'OnayKutuluTablo' || Form.type == 'CoktanSecmeliTablo'">
                      <th :key="index" v-for="(Satir, index) in Form.options.Satir">
                        {{ Satir.value }}
                      </th>
                    </template>
                  </template>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="Cevap in CevapData" :key="Cevap.Id" class="left-aligned-cell">
                <template v-for="Bolumler in FormJson">
                  <template v-for="(Form, index) in Bolumler.FormFiled">
                    <td :key="index" v-if="Form.type != 'OnayKutuluTablo' && Form.type != 'CoktanSecmeliTablo'">
                      <template v-for="(FieldCevap, index) in JSON.parse(Cevap.cevap)">
                        <template v-if="index == Form.Id" >
                          <div :key="index" class="left-aligned-cell">
                            <div  v-if="FieldCevap.Type == 'input' || FieldCevap.Type == 'time' || FieldCevap.Type == 'date' || FieldCevap.Type == 'textarea' || FieldCevap.Type == 'rangeslider'">
                              {{ FieldCevap.Cevap }}
                            </div>
                            <div v-else-if="FieldCevap.Type == 'file'">
                              <i class="fas fa-download" @click="FileDowland(FieldCevap.Cevap)"></i> 
                            </div>

                            <div v-else-if="(FieldCevap.Type == 'radiobutton') || FieldCevap.Type == 'combobox'">
                              <template v-if="(FieldCevap.Type == 'radiobutton' &&  Form.options.length > 0) || FieldCevap.Type == 'combobox'">
                              <div v-for="(Cevap, index) in Form.options.filter((x) => x.Id == FieldCevap.Cevap)" :key="index">
                                {{ Cevap.value }}
                              </div>
                              </template>
                            </div>

                            <div v-else-if="FieldCevap.Type == 'checkbox'">
                              <template v-for="(FieldCevaplar, FieldCevaplarindex) in FieldCevap.Cevap">
                                <div :key="FieldCevaplarindex">
                                  <div v-for="(Cevap, index) in Form.options.filter((x) => x.Id == FieldCevaplarindex)" :key="index">{{ Cevap.value }},</div>
                                </div>
                              </template>
                            </div>
                            <div v-else>
                              {{ FieldCevap }}
                            </div>
                          </div>
                        </template>
                      </template>
                    </td>

                    <template v-if="Form.type == 'OnayKutuluTablo'">
                     <td :key="index" v-for="(Satir, index) in Form.options.Satir" class="left-aligned-cell">
                        <template v-for="(FieldCevap, index) in JSON.parse(Cevap.cevap)">
                          <template v-if="index == Form.Id">
                            <div :key="index">
                              <template v-for="(FieldCevaplar, FieldCevaplarindex) in FieldCevap.Cevap">
                                <div :key="FieldCevaplarindex" v-if="FieldCevaplarindex == Satir.Id">
                                  <div v-for="(FieldCevaplarAlt, index) in FieldCevap.Cevap[FieldCevaplarindex]" :key="index">
                                    <div :key="index">
                                      <div v-for="(Cevap, index) in Form.options.Sutun.filter((x) => x.Id == index)" :key="index">{{ Cevap.value }},</div>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </template>
                        </template>
                      </td>
                    </template>

                    <template v-if="Form.type == 'CoktanSecmeliTablo'">
                      <td :key="index" v-for="(Satir, index) in Form.options.Satir" class="left-aligned-cell">
                        <template v-for="(FieldCevap, index) in JSON.parse(Cevap.cevap)">
                          <template v-if="index == Form.Id">
                            <div :key="index">
                              <template v-for="(FieldCevaplar, FieldCevaplarindex) in FieldCevap.Cevap">
                                <div :key="FieldCevaplarindex">
                                  <div :key="index" v-if="FieldCevaplarindex == Satir.Id">
                                    <div v-for="(Cevap, index) in Form.options.Sutun.filter((x) => x.Id == FieldCevaplar)" :key="index">{{ Cevap.value }},</div>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </template>
                        </template>
                      </td>
                    </template>
                  </template>
                </template>
              </tr>
            </tbody>
          </table>
          <br />
          <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
        </div>
      </div>
    </div>
  </Loader>
</template>
<style>
.left-aligned-cell {
  text-align: left;
}
</style>
